import type { Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useNotifications(userId: Ref<number>, cursor?: Ref<string | undefined>) {
  const queryKey = computed(() => queryKeys.NOTIFICATIONS.LIST(userId.value, cursor?.value))

  const fetchNotifications = async () => {
    const res = await financialBff('query')({
      notifications: [
        { userId: userId.value, cursor: cursor?.value },
        {
          count: true,
          data: {
            clickedAt: true,
            createdAt: true,
            id: true,
            notification: {
              actionUrl: true,
              message: true,
              templateName: true,
              title: true,
            },
            readAt: true,
          },
          nextCursor: true,
          nextPage: true,
          previousCursor: true,
          previousPage: true,
          totalCount: true,
          metrics: {
            totalCount: true,
            totalUnclickedCount: true,
            totalUnreadCount: true,
          },
        },
      ],
    })
    return res.notifications
  }

  return useQuery({
    queryKey,
    queryFn: fetchNotifications,
    retry: 3,
    retryDelay: 1000,
    staleTime: 1000 * 60 * 1,
  })
}

export type ApiNotifications = ReturnType<typeof useNotifications>['data']['value']
export type ApiMetrics = NonNullable<ReturnType<typeof useNotifications>['data']['value']>['metrics']
export type ApiNotificationsData = NonNullable<ReturnType<typeof useNotifications>['data']['value']>['data']
